"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavProfile = void 0;
var React = require("react");
var Icons = require("../Icons");
var UserAvatar_1 = require("../UserAvatar");
var semantic_ui_react_1 = require("semantic-ui-react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var Toggle_1 = require("../Toggle");
var NavProfile = /** @class */ (function (_super) {
    __extends(NavProfile, _super);
    function NavProfile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderManagePTDContentSection = function (_a) {
            var toggle = _a.toggle;
            return _this.renderSection({
                iconName: 'Pencil',
                content: 'Manage PTD Content',
                clickHandler: _this.props.onManagePTDContentClicked,
                toggle: toggle,
            });
        };
        _this.iconFactory = function (name /* todo : make more specific*/) {
            var m = {
                Support: Icons.Support,
                SmallCustomFields: Icons.SmallCustomFields,
                Sliders: Icons.Sliders,
                Logout: Icons.Logout,
                Pencil: Icons.Pencil,
            };
            return m[name];
        };
        return _this;
    }
    NavProfile.prototype.render = function () {
        var _this = this;
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName, email = _a.email;
        var initials = "" + firstName[0] + lastName[0];
        return (React.createElement(Toggle_1.Toggle, null, function (_a) {
            var toggle = _a.toggle, on = _a.on;
            return (React.createElement(semantic_ui_react_1.Popup, { open: on, onOpen: function (e) {
                    if (e.type !== 'click') {
                        return;
                    }
                    toggle();
                }, onClose: function (e) {
                    if (e.type !== 'click') {
                        return;
                    }
                    toggle();
                }, closeOnDocumentClick: true, hideOnScroll: true, openOnTriggerClick: true, basic: true, trigger: React.createElement("div", null,
                    React.createElement(UserAvatar_1.UserAvatar, { text: initials, dataTags: {
                            test: 'NAV_PROFILE_USER_AVATAR',
                        } })), closeOnTriggerClick: true },
                React.createElement(PopupMenu, null,
                    React.createElement(PopupMenuList, null,
                        React.createElement("li", { className: "header" },
                            React.createElement("div", { className: "" },
                                React.createElement(UserAvatar_1.UserAvatar, { text: initials, size: "medium" })),
                            React.createElement("div", { style: { cursor: 'default' } },
                                React.createElement(Name, null, firstName + " " + lastName),
                                React.createElement(Email, null, email))),
                        React.createElement(Divider, null),
                        _this.renderSections({ toggle: toggle })))));
        }));
    };
    NavProfile.prototype.renderSections = function (_a) {
        var toggle = _a.toggle;
        // TODO: investigate more terse way of doing this that maintains this level of extensibility
        return (React.createElement(React.Fragment, null,
            this.shouldShowSection('Settings') &&
                this.renderSettingsSection({ toggle: toggle }),
            this.shouldShowSection('Manage Custom Fields') &&
                this.renderManageFieldsSection({ toggle: toggle }),
            this.shouldShowSection('Manage PTD Content') &&
                this.renderManagePTDContentSection({ toggle: toggle }),
            this.shouldShowSection('Support') && this.renderSupportSection(),
            this.renderLogoutSection({ toggle: toggle })));
    };
    NavProfile.prototype.renderLogoutSection = function (_a) {
        var toggle = _a.toggle;
        return this.renderSection({
            iconName: 'Logout',
            content: 'Logout',
            clickHandler: this.props.logout,
            showDivider: false,
            toggle: toggle,
        });
    };
    NavProfile.prototype.renderManageFieldsSection = function (_a) {
        var toggle = _a.toggle;
        return this.renderSection({
            iconName: 'SmallCustomFields',
            content: 'Manage Custom Fields',
            clickHandler: this.props.onManageFieldsClicked,
            toggle: toggle,
        });
    };
    NavProfile.prototype.renderSettingsSection = function (_a) {
        var toggle = _a.toggle;
        return this.renderSection({
            iconName: 'Sliders',
            content: 'Profile Settings',
            clickHandler: this.props.onPreferencesClicked,
            toggle: toggle,
        });
    };
    NavProfile.prototype.renderSupportSection = function () {
        return this.renderSection({
            iconName: 'Support',
            content: (React.createElement("a", { rel: "noopener noreferrer", target: "_blank", href: "https://120water.com/support", style: { color: '#000000de' } }, "Support")),
            showDivider: true,
        });
    };
    NavProfile.prototype.renderSection = function (_a) {
        var iconName = _a.iconName, _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { } : _b, showDivider = _a.showDivider, content = _a.content, toggle = _a.toggle;
        if (showDivider === undefined && !this.props.hideMiddleDividers) {
            showDivider = true;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(PopupMenuListItem, { itemVerticalPadding: this.props.itemVerticalPadding, onClick: function () {
                    clickHandler();
                    typeof toggle === 'function' && toggle();
                } },
                this.iconFactory(iconName)({}),
                React.createElement("span", null, content)),
            showDivider && React.createElement(Divider, null)));
    };
    NavProfile.prototype.shouldShowSection = function (sectionName) {
        var sectionsToHide = this.props.sectionsToHide;
        if (!sectionsToHide) {
            return true;
        }
        return !sectionsToHide.find(function (name) { return name === sectionName; });
    };
    return NavProfile;
}(React.Component));
exports.NavProfile = NavProfile;
var PopupMenu = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 16px;\n  width: auto;\n"], ["\n  background: ", ";\n  border-radius: 16px;\n  width: auto;\n"])), theme_1.colors.white);
var PopupMenuList = styled_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0px;\n  padding: 0px;\n  border-radius: 0.66rem;\n\n  .header {\n    display: flex;\n    padding: 1.33rem;\n\n    & > div {\n      margin-right: 1.33rem;\n    }\n  }\n"], ["\n  list-style: none;\n  margin: 0px;\n  padding: 0px;\n  border-radius: 0.66rem;\n\n  .header {\n    display: flex;\n    padding: 1.33rem;\n\n    & > div {\n      margin-right: 1.33rem;\n    }\n  }\n"])));
var PopupMenuListItem = styled_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.16rem;\n  padding: ", " 0.66rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n\n  span {\n    margin-left: 0.66rem;\n  }\n\n  & svg g {\n    fill: ", ";\n    opacity: 0.5;\n  }\n\n  &:hover {\n    & svg g {\n      opacity: 1;\n    }\n\n    & svg.support g {\n      fill: ", ";\n    }\n\n    & svg.logout g {\n      fill: ", ";\n    }\n  }\n"], ["\n  font-size: 1.16rem;\n  padding: ", " 0.66rem;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n\n  span {\n    margin-left: 0.66rem;\n  }\n\n  & svg g {\n    fill: ", ";\n    opacity: 0.5;\n  }\n\n  &:hover {\n    & svg g {\n      opacity: 1;\n    }\n\n    & svg.support g {\n      fill: ", ";\n    }\n\n    & svg.logout g {\n      fill: ", ";\n    }\n  }\n"])), function (props) { return props.itemVerticalPadding || '1.33rem'; }, theme_1.colors.black, theme_1.colors.primary, theme_1.colors.error);
var Divider = styled_1.default.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  opacity: 0.25;\n  box-shadow: inset 0 -1px 0 0 #00242d;\n  padding: 0px;\n  height: 1px;\n"], ["\n  opacity: 0.25;\n  box-shadow: inset 0 -1px 0 0 #00242d;\n  padding: 0px;\n  height: 1px;\n"])));
var Name = styled_1.default.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 1.16rem;\n  font-weight: bold;\n  margin-bottom: 0;\n"], ["\n  font-size: 1.16rem;\n  font-weight: bold;\n  margin-bottom: 0;\n"])));
var Email = styled_1.default.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.16rem;\n  font-weight: 300;\n  opacity: 0.5;\n"], ["\n  font-size: 1.16rem;\n  font-weight: 300;\n  opacity: 0.5;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map